import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBagIcon, XIcon, BadgeCheckIcon } from "lucide-react";
import { recentBuyers } from "../data/content";
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * recentBuyers.length));
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    const cycle = () => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), 5000);
    };
    const first = window.setTimeout(cycle, 7000);
    const interval = window.setInterval(cycle, 15000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(interval);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 sm:inset-x-auto sm:bottom-6 sm:left-6" aria-live="polite" data-id="element-39" data-mp="164xpv1wbcwmo">
      <AnimatePresence data-id="element-40" data-mp="116micxthqy7m">
        {show && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-card sm:w-[360px]" data-id="element-41" data-mp="1fw27yahacxlq">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-successSoft text-success" data-id="element-42" data-mp="x382q89gsjup">
              <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-43" data-mp="28k7qqros4cix" />
            </div>
            <div className="min-w-0" data-id="element-44" data-mp="23lda9weab01z">
              <p className="text-sm leading-snug text-ink" data-id="element-45" data-mp="23kblyq89ch2b">
                <span className="font-bold" data-id="element-46" data-mp="2aol7qmdxes7h">{buyer.name}</span> from <span className="font-bold" data-id="element-47" data-mp="2anrwp97xpgjj">{buyer.country}</span>{" "}
                just bought the digital book
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-muted" data-id="element-48" data-mp="2fph9atat229q">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-success" aria-hidden="true" data-id="element-49" data-mp="2kko5lg1qw4om" />
                Verified purchase · {buyer.ago}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:bg-paper hover:text-ink" aria-label="Close notification" data-id="element-50" data-mp="1rzeh8d6w4wb4">
              <XIcon className="h-4 w-4" data-id="element-51" data-mp="26nrjfrwknbe2" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}